export default function OeeTab({ xl }) {
  const { Kpi, Table, avg, pct, lines, rows } = xl;
  return (
          <>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">OEE analyse</h1>
            <p className="text-sm text-slate-500 mb-6">Beschikbaarheid × Prestatie × Kwaliteit.</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <Kpi label="OEE (gem.)" value={pct(avg(rows, (r) => r.oee))} />
              <Kpi label="Beschikbaarheid" value={pct(avg(rows, (r) => r.beschikbaarheid))} />
              <Kpi label="Prestatie" value={pct(avg(rows, (r) => r.prestatie))} />
              <Kpi label="Kwaliteit" value={pct(avg(rows, (r) => r.kwaliteit))} />
            </div>
            <Table columns={["Lijn", "OEE", "Beschikbaarheid", "Prestatie", "Kwaliteit"]}
              rows={lines.map((l) => { const f = rows.filter((r) => r.lijn === l.naam); return [l.naam, pct(avg(f, (r) => r.oee)), pct(avg(f, (r) => r.beschikbaarheid)), pct(avg(f, (r) => r.prestatie)), pct(avg(f, (r) => r.kwaliteit))]; })} />
          </>
  );
}
